import {useApiEnums} from './useApiEnums';

/** Feature label lookup over the flat enum, so collapsed parent keys resolve too. */
export function useFeatureLabels() {
  const {getEnum, isLoading, isError} = useApiEnums({flat: true});

  const labelsByKey = new Map(getEnum('feature').map((item) => [item.value, item.label]));

  return {
    getFeatureLabel: (key: string) => labelsByKey.get(key) ?? key,
    isKnownFeature: (key: string) => labelsByKey.has(key),
    isLoading,
    isError,
  };
}
